import CryptoJS from "./aes"; //引用AES源码js
import { loginUserCode } from "../apis/commonApi";

//上传url
export const BASE_UPLOAD_URL = `${process.env.REACT_APP_BASE_API}crm-venus/v1/venus/files/fileUpload/default`;
//文件
export const BASE_DOWNLOAD_URL = `${process.env.REACT_APP_BASE_API}crm-venus/v1/venus/files/download/`;
//图片
export const BASE_IMAGE_PREFIX = `${process.env.REACT_APP_BASE_API}crm-venus/v1/venus/images/`;

const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥偏移量

//解密方法
export const Decrypt = (word) => {
  let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

//加密方法
export const Encrypt = (word) => {
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
};

export const getToken = (userCode = "10006720") => {
  const account = Encrypt(userCode);
  const password = Encrypt(
    CryptoJS.MD5(userCode.substring(userCode.length - 6)).toString()
  );
  // const params = new FormData();
  // params.append("account", account);
  // params.append("password", password);
  // params.append("appType", 3);
  const params = {
    account,
    password,
    appType: 3,
  };
  return loginUserCode(params);
};
